/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs';

export class SearchBoxDatabinding {
  data: any[] | null;
  // -2 - Fehlende Implementierung / -1 - Fehler beim Datenbezug / 0 - Keine Daten gefunden / 1 - Anzeigen der Daten
  status: number;
  dropDownShown: boolean;
  customColumns: any[];

  constructor(
    public label: string,
    public searchName: string,
    public useRefetchFromServerMode: boolean,
    public useSeperateGetDataForEmptySearch = true,
    public hideDropDown = false,
    public searchTermMinLength = 3,
  ) {
    this.data = null;
    this.status = 1;
    this.dropDownShown = true;
  }

  /** Überschreiben für den Datenbezug, wenn useRefetchFromServerMode aktiviert ist
   * @param searchTerm  Der Suchbegriff welcher abgefragt werden soll
   * @returns Ein Observable, welches das Resultat für die Anzeige zurückliefert
   */
  getData(searchTerm: string): Observable<any> {
    return new Observable();
  }

  /** Überschreiben für separaten Datenbezug, wenn Suchstring leer ist und useRefetchFromServerMode als auch
   * useSeperateGetDataForEmptySearch aktiviert ist
   * @returns Ein Observable, welches das Resultat für die Anzeige zurückliefert oder of('Leeren') zum Leeren der Anzeige verwenden
   */
  getEmptySearchData(): Observable<any> {
    return new Observable();
  }

  /** Überschreiben für die Verarbeitung des Resultats, wenn useRefetchFromServerMode aktiviert ist
   * @param result Das Resultat für die Anzeige, welches gecastet werden sollte
   */
  handleResult(result: any): void {}

  /** Überschreiben für die Darstellung der ausgewählten Zeile im Input der Dropdown, wenn man customColumns verwendet
   * @param selectedRow Die ausgewählte Zeile
   * @returns Der Text, welcher im Input des Dropdowns stehen soll
   */
  getSelectedRowFormat(selectedRow: any): string {
    return '(not defined)';
  }

  clear() {
    this.data = null;
    this.status = 1;
    this.dropDownShown = true;
  }
}
